import React from 'react';
import { SNAPSHOT } from '../../data/content';
import StatCard from '../StatCard';
import SectionHeader from '../SectionHeader';
import { useIntersection } from '../../hooks/useIntersection';

const gridStyle = {
  display: 'grid', gridTemplateColumns: 'repeat(4,1fr)',
  gap: '1px', background: '#D1D5DB',
  border: '1px solid #D1D5DB', borderRadius: 10,
  overflow: 'hidden', marginBottom: 24,
};

export default function Snapshot() {
  const { ref, visible } = useIntersection();
  const first = SNAPSHOT.stats.slice(0, 4);
  const second = SNAPSHOT.stats.slice(4);

  return (
    <section id="snapshot" style={{ padding: '72px 0', borderBottom: '1px solid #D1D5DB' }}>
      <div className="r25-section-wrap" style={{ maxWidth: 'var(--max)', margin: '0 auto', padding: '0 40px' }}>
        <SectionHeader num={SNAPSHOT.sectionNum} title={SNAPSHOT.title} titleEm={SNAPSHOT.titleEm} body={SNAPSHOT.body} />
        <div ref={ref} className={`fade-in${visible ? ' visible' : ''}`}>
          <div className="r25-grid-4" style={gridStyle}>
            {first.map((s, i) => <StatCard key={i} {...s} trigger={visible} />)}
          </div>
          <div className="r25-grid-4" style={{ ...gridStyle, marginBottom: 0 }}>
            {second.map((s, i) => <StatCard key={i} {...s} trigger={visible} />)}
          </div>
        </div>
      </div>
    </section>
  );
}
